import { LazyModule, LazyImport } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "InboxPlusPivotEnableDisableDialog", webpackPrefetch: true */ './lazyIndex')
);

export let lazyShowPivotEnableDisableDialog = new LazyImport(
    lazyModule,
    m => m.showPivotEnableDisableDialog
);
